var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 33,
    viewBox: "0 0 133 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0134 4.90143C43.0134 5.87623 42.7175 6.63441 42.1525 7.20304C41.5069 7.87999 40.646 8.232 39.6238 8.232C38.6284 8.232 37.7945 7.87999 37.0951 7.20304C36.3956 6.49902 36.0459 5.65961 36.0459 4.63065C36.0459 3.60169 36.3956 2.7352 37.0951 2.05826C37.7945 1.35423 38.6284 1.0293 39.6238 1.0293C40.108 1.0293 40.5922 1.13761 41.0496 1.32715C41.5069 1.5167 41.8566 1.78748 42.1256 2.11241L41.5338 2.70812C41.0765 2.16657 40.4577 1.89579 39.6507 1.89579C38.9244 1.89579 38.3056 2.16657 37.7676 2.65397C37.2296 3.16845 36.9874 3.84539 36.9874 4.65773C36.9874 5.47006 37.2565 6.14701 37.7676 6.66149C38.3056 7.17597 38.9244 7.41967 39.6507 7.41967C40.4308 7.41967 41.0496 7.14889 41.5607 6.63441C41.8835 6.30948 42.0718 5.82208 42.1256 5.22636H39.6238V4.38695H42.9596C42.9865 4.57649 43.0134 4.73896 43.0134 4.90143Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182963,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2857 2.00152H45.1382V4.19483H47.9628V5.03424H45.1382V7.22754H48.2857V8.09403H44.2773V1.16211H48.2857V2.00152Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182963,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0263 8.09403H51.1385V2.00152H49.2285V1.16211H53.9632V2.00152H52.0532L52.0263 8.09403Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182963,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3779 8.09403V1.16211H58.2657V8.09403H57.3779Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182963,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1933 8.09403H61.3055V2.00152H59.3955V1.16211H64.1302V2.00152H62.2202V8.09403H62.1933Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182963,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0612 7.20082C72.3886 7.90485 71.5547 8.25686 70.5324 8.25686C69.5371 8.25686 68.6762 7.90485 68.0037 7.20082C67.3312 6.4968 66.9814 5.63031 66.9814 4.62843C66.9814 3.62655 67.3043 2.76006 68.0037 2.05604C68.6762 1.35201 69.5102 1 70.5324 1C71.5278 1 72.3617 1.35201 73.0612 2.05604C73.7337 2.76006 74.0834 3.62655 74.0834 4.62843C74.0834 5.63031 73.7337 6.4968 73.0612 7.20082ZM68.6762 6.60511C69.1874 7.11959 69.8061 7.39037 70.5593 7.39037C71.2857 7.39037 71.9313 7.11959 72.4424 6.60511C72.9535 6.09063 73.2226 5.41369 73.2226 4.62843C73.2226 3.84317 72.9535 3.16623 72.4424 2.65175C71.9313 2.13727 71.3126 1.86649 70.5593 1.86649C69.833 1.86649 69.1874 2.13727 68.6762 2.65175C68.1651 3.16623 67.923 3.84317 67.923 4.62843C67.923 5.41369 68.1651 6.09063 68.6762 6.60511Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182963,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3223 8.09403V1.16211H76.3983L79.761 6.5506H79.7879L79.761 5.22378V1.16211H80.6488V8.09403H79.7341L76.2369 2.43477H76.21L76.2369 3.76158V8.09403H75.3223Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182963,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7953 18.1946C64.1052 18.1946 61.8993 20.2525 61.8993 23.1228C61.8993 25.9389 64.1052 28.0509 66.7953 28.0509C69.4855 28.0509 71.6914 25.9389 71.6914 23.1228C71.6914 20.2796 69.4855 18.1946 66.7953 18.1946ZM66.7953 26.1013C65.3157 26.1013 64.0514 24.8828 64.0514 23.1228C64.0514 21.3627 65.3157 20.1442 66.7953 20.1442C68.2749 20.1442 69.5393 21.3627 69.5393 23.1228C69.5393 24.8557 68.2749 26.1013 66.7953 26.1013ZM56.0886 18.1946C53.3984 18.1946 51.1925 20.2525 51.1925 23.1228C51.1925 25.9389 53.3984 28.0509 56.0886 28.0509C58.7787 28.0509 60.9846 25.9659 60.9846 23.1228C60.9846 20.2796 58.8056 18.1946 56.0886 18.1946ZM56.0886 26.1013C54.609 26.1013 53.3446 24.8828 53.3446 23.1228C53.3446 21.3627 54.609 20.1442 56.0886 20.1442C57.5681 20.1442 58.8325 21.3627 58.8325 23.1228C58.8594 24.8557 57.5681 26.1013 56.0886 26.1013ZM43.3911 19.711V21.7959H48.3409C48.1795 22.9603 47.8029 23.8268 47.2111 24.4225C46.4847 25.1536 45.3549 25.9389 43.3911 25.9389C40.3512 25.9389 37.957 23.4748 37.957 20.3879C37.957 17.301 40.3512 14.8369 43.3911 14.8369C45.0321 14.8369 46.2426 15.4868 47.1304 16.3262L48.5831 14.864C47.3456 13.6726 45.7046 12.752 43.3911 12.752C39.2214 12.752 35.6973 16.1908 35.6973 20.3879C35.6973 24.585 39.2214 28.0239 43.3911 28.0239C45.6508 28.0239 47.3456 27.2657 48.6907 25.8847C50.0626 24.5037 50.4931 22.5812 50.4931 21.0107C50.4931 20.5233 50.4662 20.09 50.3854 19.711C50.3585 19.711 43.3911 19.711 43.3911 19.711ZM95.3915 21.3356C94.988 20.2254 93.7506 18.1946 91.2218 18.1946C88.6931 18.1946 86.6217 20.1984 86.6217 23.1228C86.6217 25.8847 88.6931 28.0239 91.4639 28.0239C93.6968 28.0239 94.988 26.6429 95.5261 25.8576L93.8582 24.7474C93.2932 25.5598 92.54 26.1013 91.4639 26.1013C90.3879 26.1013 89.6077 25.5868 89.0966 24.612L95.6337 21.9043L95.3915 21.3356ZM88.7469 22.9603C88.6931 21.0648 90.1996 20.09 91.3025 20.09C92.1634 20.09 92.8628 20.5233 93.1049 21.119L88.7469 22.9603ZM83.4204 27.726H85.5725V13.2935H83.4204V27.726ZM79.8963 19.3048H79.8156C79.3314 18.7362 78.4167 18.1946 77.2331 18.1946C74.785 18.1946 72.5522 20.3608 72.5522 23.1228C72.5522 25.8847 74.785 28.0239 77.2331 28.0239C78.3898 28.0239 79.3314 27.5094 79.8156 26.9137H79.8963V27.6177C79.8963 29.4861 78.901 30.515 77.2869 30.515C75.9687 30.515 75.1617 29.5673 74.8389 28.755L72.9827 29.5402C73.5207 30.8399 74.9465 32.4375 77.3138 32.4375C79.8425 32.4375 81.9677 30.9483 81.9677 27.3198V18.4925H79.9232L79.8963 19.3048ZM77.4483 26.1013C75.9687 26.1013 74.7312 24.8557 74.7312 23.1498C74.7312 21.4169 75.9687 20.1442 77.4483 20.1442C78.901 20.1442 80.0577 21.4169 80.0577 23.1498C80.0577 24.8557 78.901 26.1013 77.4483 26.1013ZM105.453 13.2935H100.315V27.726H102.467V22.2563H105.453C107.82 22.2563 110.16 20.5233 110.16 17.7614C110.16 14.9994 107.82 13.2935 105.453 13.2935ZM105.506 20.2525H102.467V15.2973H105.506C107.121 15.2973 108.008 16.6241 108.008 17.7614C108.008 18.8986 107.094 20.2525 105.506 20.2525ZM118.742 18.1675C117.182 18.1675 115.595 18.8445 114.922 20.3879L116.832 21.1732C117.236 20.3879 117.989 20.1171 118.796 20.1171C119.899 20.1171 121.029 20.7941 121.056 21.9855V22.148C120.679 21.9313 119.845 21.5793 118.823 21.5793C116.778 21.5793 114.68 22.7166 114.68 24.8287C114.68 26.7512 116.348 27.9968 118.231 27.9968C119.684 27.9968 120.464 27.3469 120.975 26.5887H121.056V27.6989H123.127V22.148C123.1 19.6026 121.19 18.1675 118.742 18.1675ZM118.473 26.1013C117.774 26.1013 116.805 25.7493 116.805 24.8828C116.805 23.7726 118.016 23.3394 119.065 23.3394C120.006 23.3394 120.437 23.556 121.029 23.8268C120.867 25.1536 119.71 26.1013 118.473 26.1013ZM130.632 18.4925L128.184 24.7474H128.104L125.548 18.4925H123.235L127.055 27.2386L124.876 32.1126H127.108L133 18.4925H130.632ZM111.344 27.726H113.496V13.2935H111.344V27.726Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.538029 1.9953C0.215211 2.34731 0 2.88886 0 3.61997V29.1814C0 29.8855 0.18831 30.4541 0.538029 30.8061L0.618733 30.8873L14.8496 16.5632V16.4007V16.2382L0.618733 1.91406L0.538029 1.9953Z",
    fill: "url(#paint0_linear_8982_13591)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5843 21.12L14.8496 16.3543V16.1918V16.0294L19.5843 11.2637L19.6919 11.3178L25.3143 14.5401C26.9284 15.4607 26.9284 16.95 25.3143 17.8707L19.6919 21.0929L19.5843 21.12Z",
    fill: "url(#paint1_linear_8982_13591)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6919 21.0654L14.8496 16.1914L0.538086 30.5968C1.07611 31.1654 1.93696 31.2196 2.93231 30.678L19.6919 21.0654Z",
    fill: "url(#paint2_linear_8982_13591)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6919 11.29L2.93231 1.70443C1.93696 1.1358 1.07611 1.21703 0.538086 1.78567L14.8496 16.1911L19.6919 11.29Z",
    fill: "url(#paint3_linear_8982_13591)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.5838 20.9551L2.93178 30.4865C1.99023 31.028 1.15629 30.9739 0.645158 30.5136L0.564453 30.5948L0.645158 30.676C1.18319 31.1634 2.01713 31.1905 2.93178 30.6489L19.6914 21.0634L19.5838 20.9551Z",
    fill: "#131313"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.538029 30.4059C0.215212 30.0539 0 29.4853 0 28.7812V28.9437C0 29.6477 0.18831 30.2164 0.538029 30.5684L0.618733 30.4872L0.538029 30.4059Z",
    fill: "#131313"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M25.315 17.6785L19.585 20.9549L19.6926 21.0632L25.315 17.8409C26.122 17.3806 26.5255 16.7849 26.5255 16.1621C26.4448 16.7307 26.0413 17.2723 25.315 17.6785Z",
    fill: "#131313"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2.93172 1.86624L25.3137 14.6741C26.04 15.0802 26.4436 15.6218 26.5243 16.1633C26.5243 15.5676 26.1208 14.9448 25.3137 14.4845L2.93172 1.70378C1.31764 0.78313 0.0263672 1.54131 0.0263672 3.40968V3.57215C0.0263672 1.73085 1.31764 0.945597 2.93172 1.86624Z",
    fill: "#131313"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8982_13591",
    x1: 13.5941,
    y1: 3.34163,
    x2: -5.79836,
    y2: 22.6077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8982_13591",
    x1: 27.4093,
    y1: 16.181,
    x2: -0.369204,
    y2: 16.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8982_13591",
    x1: 17.0683,
    y1: 18.8309,
    x2: -9.22941,
    y2: 44.9573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8982_13591",
    x1: -3.05621,
    y1: -6.72918,
    x2: 8.68681,
    y2: 4.93732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.543be30d794e8c5e4d7bf2c7ad284d62.svg";
export { ForwardRef as ReactComponent };